<template>
  <div class="baseInfo-container">
    <div class="status-content" v-if="statusName">
      <p class="status-name">{{statusName}}</p>
      <span class="reason">{{userData.basedataAuth === 2 && userData.basedataAuthReason ? userData.basedataAuthReason : ''}}</span>
    </div>

    <template v-if="userData.firstBaseAuth === 0">
      <div class="info-tags">
        <p class="tag-group">
          <span class="tag">{{sexMap[userData.sex]}}</span>
          <span class="tag">{{educationMap[userData.education]}}</span>
          <span class="tag">{{userData.birthday}}</span>
          <!-- /{{userData.birthday ? calculater(userData.birthday.split('-')[0]) : ''}}/{{constellationMap[userData.constellation] -->
        </p>
        <p class="tag-group">
          <span class="tag">身高：{{userData.high}}cm</span>
          <span class="tag">手机号：{{infoData.mobile}}</span>
        </p>
      </div>
      <div class="complete-info-box">
        <span class="complete-info">请补充以下资料</span>
      </div>
    </template>

    <div class="imgs-content">
      <p class="upload-tips">
        <span class="title"><b>照片</b></span>
        <span class="sub-title">（至少展示2张，最多9张）</span>
      </p>

      <div class="upload-content" v-if="infoData.id">
        <template v-for="(img, index) in infoData.coverPicUrlList">
          <template v-if="index === 0">
            <div class="upload-item clip-item" :class="!img ? ['select-item', 'uploadModel'] : ''" :key="index">
              <template v-if="img">
                <img :src="img" alt="" class="img-item" @click="showPreview(index)"/>
                <img src="~@/assets/img/close-white.png" alt="" v-if="isEditable" class="delete-btn"
                  @click.stop="deleteImg(index)" />
              </template>
              <template v-else>
                <Oss @fileChange="selectedImg" @uploadSucess="coverPicSuccess" browse_button="uploadClipBtn"
                  :actionFile="coverClipFile" :originFile="clipOriginFile" container="coverContainer" :params='clipParams' :isClip="true">
                  <div id="coverContainer">
                    <div id="uploadClipBtn">
                      <img src="~@/assets/img/upload-bg-other.png" class="upload-btn" />
                      <span class="uploadTips">上传封面照</span>
                    </div>
                  </div>
                </Oss>
                <div id="upload-request-mask" @click="showUploadRequestModal = true" v-if="showUploadRequest"></div>
              </template>
              <span class="clipUploadTips">展示在首页列表</span>
            </div>
          </template>
          <div class="upload-item" v-else :key="index">
            <img :src="img" alt="" class="img-item" @click="showPreview(index)"/>
            <img src="~@/assets/img/close-white.png" alt="" v-if="isEditable" class="delete-btn"
              @click.stop="deleteImg(index)" />
          </div>
        </template>
        <div class="upload-item select-item uploadModel"
          v-if="isEditable && (!infoData.coverPicUrlList || infoData.coverPicUrlList.length < 9)">
          <Oss @fileChange="selectedOriginImg" @uploadSucess="originPicSuccess" browse_button="uploadBtn"
            :actionFile="coverFile" container="coverContainer" :params='coverParams'>
            <div id="coverContainer">
              <div id="uploadBtn">
                <img src="~@/assets/img/upload-bg-other.png" class="upload-btn" />
                <span class="uploadTips">补充其他照片</span>
              </div>
            </div>
          </Oss>
        </div>
      </div>
    </div>

    <div class="input-form">
      <div class="input-item strong">
        <span class="name">姓名</span>
        <input type="text" :readonly="!isEditable" maxlength="6" placeholder="请输入自己的真实姓名" class="input"
          v-model="infoData.name" />
      </div>
      <div class="input-item strong">
        <span class="name">昵称</span>
        <input type="text" :readonly="!isEditable" maxlength="15" placeholder="请输入昵称" class="input"
          v-model="infoData.nickName" />
      </div>
      <div class="input-item strong select-item" @click="triggerPicker(1)">
        <span class="name"><b>所在地</b></span>
        <p class="input">
          <span class="value"
            v-if="!isForeign && areaData['city_list'][infoData.cityId]">{{areaData['city_list'][infoData.cityId]}}</span>
          <span class="placeValue" v-else>{{isForeign ? '海外' : '请选择所在地'}}</span>

          <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
        </p>
      </div>
      <div class="input-item select-item foreign-input" v-if="isForeign">
        <input type="text" :readonly="!isEditable" placeholder="海外国家名" class="input" v-model="infoData.country" />
        <input type="text" :readonly="!isEditable" placeholder="海外地区名" class="input" v-model="infoData.state" />
      </div>
      <div class="input-item strong select-item" @click="triggerPicker(0)">
        <span class="name">籍贯</span>
        <p class="input">
          <span class="value"
            v-if="!isNativeForeign && areaData['city_list'][infoData.nativeCityId]">{{areaData['city_list'][infoData.nativeCityId]}}</span>
          <span class="placeValue" v-else>{{isNativeForeign ? '海外' : '请选择籍贯'}}&nbsp;</span>

          <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
        </p>
      </div>
      <div class="input-item select-item foreign-input" v-if="isNativeForeign">
        <p class="input">
          <input type="text" :readonly="!isEditable" placeholder="海外国家名" class="input"
            v-model="infoData.nativeCountry" />
        </p>
        <input type="text" :readonly="!isEditable" placeholder="海外地区名" class="input" v-model="infoData.nativeState" />
      </div>
    </div>

    <div class="line"></div>

    <div class="input-form">
      <div class="input-item strong select-item">
        <span class="name">毕业学校</span>
        <span v-if="isEditable" class="private" :class="{checked: infoData.schollVisible === 0}">保密<i class="check-private" @click="switchEducation"><img src="~@/assets/img/tick.png" /></i></span>
        <span v-else class="private">{{infoData.schollVisible === 0 ? '保密' : '公开'}}</span>
        <input type="text" :readonly="!isEditable" placeholder="填写最高学历的学校" class="input" v-model="infoData.school" />
      </div>
      <div class="input-item strong select-item" @click="triggerPicker(6)">
        <span class="name">当前状态</span>
        <p class="input">
          <span class="value" v-if="ifStudentMap[infoData.ifStudent]">{{ifStudentMap[infoData.ifStudent]}}</span>
          <span class="placeValue" v-else>请选择</span>

          <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
        </p>
      </div>
    </div>

    <template v-if="!infoData.ifStudent">
      <div class="line"></div>

      <div class="input-form">
        <div class="input-item strong select-item">
          <span class="name">工作职位</span>
          <input type="text" :readonly="!isEditable" placeholder="填写你的职位信息" class="input" v-model="infoData.job" />
        </div>
        <div class="input-item strong select-item">
          <span class="name">公司</span>
          <span v-if="isEditable" class="private" :class="{checked: infoData.companyVisible === 0}">保密<i class="check-private" @click="switchComVisible"><img src="~@/assets/img/tick.png" /></i></span>
          <span v-else class="private">{{infoData.companyVisible === 0 ? '保密' : '公开'}}</span>
          <input type="text" :readonly="!isEditable" placeholder="当前所在公司名" class="input" v-model="infoData.company" />
        </div>
        <div class="input-item strong select-item">
          <span class="name">公司类型</span>
          <input type="text" :readonly="!isEditable" placeholder="如世界五百强/某三甲医院" class="input"
              v-model="infoData.industry" />
        </div>
        <div class="input-item strong select-item">
          <span class="name">当前年薪</span>
          <span v-if="isEditable" class="private" :class="{checked: infoData.annualSalaryVisible === 0}">保密<i class="check-private" @click="switchSalaryVisible"><img src="~@/assets/img/tick.png" /></i></span>
          <span v-else class="private">{{infoData.annualSalaryVisible === 0 ? '保密' : '公开'}}</span>
          <p class="input" @click="triggerPicker(2)">
            <span class="value" v-if="infoData.annualSalary">{{salaryMap[infoData.annualSalary]}}</span>
            <span class="placeValue" v-else>请选择</span>

            <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
          </p>
        </div>
      </div>
    </template>

    <div class="line"></div>

    <div class="input-form">
      <div class="input-item strong select-item" @click="triggerPicker(3)">
        <span class="name">婚姻状态</span>
        <p class="input">
          <span class="value" v-if="infoData.singleStatus != 0 && statusMap[infoData.singleStatus]">{{statusMap[infoData.singleStatus]}}</span>
          <span class="placeValue" v-else>请选择婚姻状态</span>

          <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
        </p>
      </div>
      <div class="input-item strong select-item" @click="triggerPicker(4)">
        <span class="name">车房情况</span>
        <p class="input">
          <span class="value" v-if="assetsMap[infoData.richesInfo]">{{assetsMap[infoData.richesInfo]}}</span>
          <span class="placeValue" v-else>请选择</span>

          <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
        </p>
      </div>
    </div>

    <div class="line"></div>

    <div class="input-form">
      <div class="input-item strong select-item" @click="triggerPicker(5)">
        <span class="name">从哪里了解hello部落</span>
        <p class="input">
          <span class="value" v-if="channelMap[infoData.channelCode]">{{channelMap[infoData.channelCode]}}</span>
          <span class="placeValue" v-else>请选择&nbsp;</span>

          <img v-if="isEditable" src="~@/assets/img/arrow-enter.png" alt="" />
        </p>
      </div>

      <div class="input-item strong" v-if="infoData.channelCode === 99">
        <span class="name">具体渠道</span>
        <input type="text" :readonly="!isEditable" placeholder="无" class="input" v-model="infoData.otherChannel" />
      </div>

      <div class="input-item strong">
        <span class="name">注册邀请码（非必填）</span>
        <input type="text" :readonly="userData.basedataAuth !== 0" placeholder="无" class="input" v-model="infoData.inviteCode" />
      </div>
    </div>

    <div class="line"></div>

    <div class="input-form textarea-form" v-if="infoData.id">
      <div class="textarea-con">
        <p class="title">自我描述</p>
        <textarea class="textarea" :readonly="!isEditable" v-model="infoData.selfDescription"
          placeholder="简单描述下自己的性格、综合情况等" :maxlength="limitLength"></textarea>
        <p class="text-num">{{infoData.selfDescription.length}}/{{limitLength}}</p>
      </div>
      <div class="textarea-con">
        <p class="title">兴趣爱好</p>
        <textarea class="textarea" :readonly="!isEditable" v-model="infoData.hobby" placeholder="喜欢的与擅长的事物"
          :maxlength="limitLength"></textarea>
        <p class="text-num">{{infoData.hobby.length}}/{{limitLength}}</p>
      </div>
      <div class="textarea-con">
        <p class="title">家庭背景</p>
        <textarea class="textarea" :readonly="!isEditable" v-model="infoData.familyInfo" placeholder="家里几口人，父母职业等"
          :maxlength="limitLength"></textarea>
        <p class="text-num">{{infoData.familyInfo.length}}/{{limitLength}}</p>
      </div>
      <div class="textarea-con">
        <p class="title">个人经历</p>
        <textarea class="textarea" :readonly="!isEditable" v-model="infoData.personalExperience"
          placeholder="工作上、生活上、感情上有过怎样的难忘经历" :maxlength="limitLength"></textarea>
        <p class="text-num">{{infoData.personalExperience.length}}/{{limitLength}}</p>
      </div>
      <div class="textarea-con">
        <p class="title">理想的另一半</p>
        <textarea class="textarea" :readonly="!isEditable" v-model="infoData.ideaPartner"
          placeholder="具体的择偶标准，如外形、身高、年龄、职业、籍贯等" :maxlength="limitLength"></textarea>
        <p class="text-num">{{infoData.ideaPartner.length}}/{{limitLength}}</p>
      </div>
      <div class="textarea-con">
        <p class="title">爱情观</p>
        <textarea class="textarea" :readonly="!isEditable" v-model="infoData.loveMind" placeholder="期待怎样的爱情，在爱情方面的态度和看法"
          :maxlength="limitLength"></textarea>
        <p class="text-num">{{infoData.loveMind.length}}/{{limitLength}}</p>
      </div>
    </div>

    <div class="line"></div>

    <div id="upload-webchat-trigger">
      <h3 class="title">上传微信账号二维码截图</h3>
      <!-- <template v-if="infoData.wechatPicUrl">
        <Oss v-if="isEditable" @uploadSucess="WebchatCodeSuccess" browse_button="uploadWebchatCodeBtn2"
          @fileChange="selectedWxCode" :actionFile="wxCodeFile" container="wxCodeContainer2" :params='wxCodeParams'>
          <div class="webchat-code" id="uploadWebchatCodeBtn2">
            
          </div>
        </Oss>
        <div class="webchat-code" v-else>
          <img class="uploaded-code" :src="infoData.wechatPicUrl" alt="" />
        </div>
      </template> -->
      <div class="webchat-code" v-if="infoData.wechatPicUrl" @click="switchwebchatPop">
        <template v-if="isEditable">
          <img class="uploaded-code" :src="infoData.wechatPicUrl" alt="" />
          <p class="reupload-word">重新上传</p>
        </template>
        <img v-else class="uploaded-code" :src="infoData.wechatPicUrl" alt="" />
      </div>
      <div class="webchat-code-item" v-else @click="switchwebchatPop">
        <img class="upload-icon" src="~@/assets/img/upload-webchat-icon.png" alt="" />
        <p class="word">点击上传</p>
      </div>
    </div>

    <div class="line"></div>
    <div id="accept-to-post">
      <h3 class="deals">愿意发帖协议</h3>
      <h3 class="title">您是否愿意在hello部落公众号上发帖晒资料</h3>
      <div class="tab-con">
        <p class="tab" v-if="isEditable || infoData.ifPost" :class="{active: infoData.ifPost === 1}" @click="switchPost(1)">愿意<img v-if="this.isEditable && infoData.ifPost === 1" src="~@/assets/img/post-active.png"></p>
        <p class="tab" v-if="isEditable || !infoData.ifPost" :class="{active: infoData.ifPost === 0}" @click="switchPost(0)">暂不发帖<img v-if="this.isEditable && infoData.ifPost === 0" src="~@/assets/img/post-active.png"></p>
      </div>
      <p class="tips">
        1、选择愿意则代表您知晓并同意在Hello部落公众号等各渠道官方账号上发帖晒资料。<br/>
        2、各渠道官方账号：官方公众号、官方微信朋友圈、官博、官方知乎号、官方豆瓣号等。 <br/>
        3、历史数据显示，通过Hello部落公众号（可能会通过各渠道官方账号转发）发帖可免费获得大量的资料报给机会，极大提升脱单几率。
      </p>
    </div>

    <div class="btns" v-if="isEditable">
      <a href="javascript:;" class="btn draft-btn" @click="saveDraft(1)">保存草稿</a>
      <a href="javascript:;" class="btn submit-btn" @click="handleSubmit">{{ userData.firstBaseAuth === 0 && userData.basedataAuth !== 2 ? '提交' : '重新提交' }}</a>
    </div>

    <!-- 上传封面须知 -->
    <van-dialog v-model="showUploadRequestModal" confirm-button-text="知道了" @close="closeRequestModal">
      <img id="upload-request-img" src="~@/assets/img/upload-request.png" alt="">
    </van-dialog>

    <AccelerateAduit v-model="isShowDialog" @confirm="confirm" @close="isShowDialog = false" :infoData="infoData"/>

    <van-popup v-model="showPicker" position="bottom">
      <van-area :area-list="filterAreaData" :show-toolbar="true" :columns-num="areaColumns"
        v-if="pickerType === 0 || pickerType === 1" :columns-placeholder="['请选择']" :value="pickerType === 1 ? infoData.cityId : infoData.nativeCityId" @change="handleAreachange"
        @confirm="handleAreaconfirm" @cancel="handleDialogcancel"></van-area>
      <van-picker v-else :columns="pickerData" :show-toolbar="true" @confirm="handlePickerConfirm"
        @cancel="handleDialogcancel"></van-picker>
    </van-popup>

    <van-popup v-model="showChatCodePop" position="bottom" class="van-popup-webchat">
      <div class="upload-code-pop">
        <!-- <div class="pop-title">
          <p class="title"></p>
          <a class="close-btn" href="javascript:;" @click="showChatCodePop = false">
            <img class="close-img" src="~@/assets/img/close.png" />
          </a>
        </div> -->
        <dl class="tips">
          <dt class="tips-title">用户微信二维码上传协议</dt>
          <dd class="tips-item">1、请上传您的真实微信二维码截图，并保证在平台对您的服务期间，<strong>他人可正常使用该二维码添加您的微信。</strong>否则您将无法正常使用本平台的交友功能。</dd>
          <dd class="tips-item">2、<strong>上传二维码则代表您同意：本平台有权将您的二维码信息发送给希望和您取得联系的单身用户。</strong></dd>
          <dd class="tips-item"> 3、当他人通过本二维码向您申请微信好友时，对方是否能通过好友申请则完全取决于您的个人意愿（通过本平台的交友服务，您可获得对方的详细单身资料和其交友申请信息）。</dd>
          <dd class="tips-item">4、本平台将严格遵守&lt;Hello部落用户协议&gt;与本协议内容。<strong>但由于交友行为本身所产生的风险需个人评估并自行承担。</strong></dd>
          <dd class="tips-item">5、交友功能说明</dd>
          <dd class="tips-item"><strong>喜欢：</strong>对方发出“喜欢”申请后，本人认可并回点“喜欢”，则双方互相公开其微信二维码。 </dd>
          <dd class="tips-item"><strong>索要微信：</strong>身份/公司/学历通过人工核查的单身用户可付费使用“索要微信”功能。若对方索要您的微信，您可获得对方的索要申请及单身资料，以此决定是否通过对方的微信好友申请。（我的-索要微信-索要我的微信） </dd>
        </dl>

        <div class="btns">
          <a href="javascript:;" class="disagree-btn" @click="showChatCodePop = false">不同意</a>
          <Oss @uploadSucess="WebchatCodeSuccess" browse_button="uploadWebchatCodeBtn1" @fileChange="selectedWxCode"
            :actionFile="wxCodeFile" container="wxCodeContainer1" :params='wxCodeParams'>
            <div id="wxCodeContainer1" @click="showChatCodePop = false">
              <span id="uploadWebchatCodeBtn1" class="upload-btn">
                我同意该协议
              </span>
            </div>
          </Oss>
        </div>
      </div>
    </van-popup>

    <Clip v-model="isShowClip" :img="tempImg" @clipComplete="clipComplete" />

    <van-image-preview v-if="infoData.coverPicUrlList" v-model="isShowPreview" :images="infoData.coverPicUrlList" :start-position="previewIndex"></van-image-preview>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Oss from '@/components/common/oss'
import Clip from '@/components/common/clip'
import AccelerateAduit from '@/components/dialog/accelerateAduit'
import qs from 'qs'
import { UPLOAD_TYPE } from '@/config/constant'

import { isIOS, transferBytes, watermark } from '@/utils/tools'
import Storage from '@/utils/Storage'
import wxApi from '@/utils/wxAuth'

// 是否首次进入，决定需不需要在 activated 钩子函数保存草稿
let isFirstEnter = true

export default {
  name: 'BaseInfo',
  components: {
    Clip,
    AccelerateAduit,
    Oss
  },
  computed: {
    ...mapState({
      userData: 'userData',
      sexMap: 'sexMap',
      educationMap: 'educationMap',
      salaryMap: 'salaryMap',
      assetsMap: 'assetsMap',
      statusMap: 'statusMap',
      constellationMap: 'constellationMap',
      channelMap: 'channelMap',
      ifStudentMap: 'ifStudentMap',
      areaData: 'areaData'
    }),
    filterAreaData () {
      let a = JSON.parse(JSON.stringify(this.areaData))
      delete a.province_list['100000']
      delete a.city_list['100100']
      return a
    },
    ...mapGetters({
      userId: 'userId',
      mId: 'mId'
    }),
    isEditable () {
      return this.userData.basedataAuth !== 1
    },
    statusName () {
      if (this.userData.firstBaseAuth) {
        if (this.userData.basedataAuth === 1) {
          return '资料修改待审核中，请稍后…'
        }
        if (this.userData.basedataAuth === 2) {
          return '资料修改审核不通过'
        }
        if (this.userData.basedataAuth === 3) {
          // return '资料修改审核通过，已生效'
          return ''
        }
      } else if (this.userData.basedataAuth === 2) {
        return '资料审核不通过'
      }
    },
    salaryArr () {
      let arr = []
      for (let i in this.salaryMap) {
        arr.push({
          value: i,
          text: this.salaryMap[i]
        })
      }
      // 去掉不限状态
      arr.shift(0)
      return arr
    },
    statusArr () {
      let arr = []
      for (let i in this.statusMap) {
        arr.push({
          value: i,
          text: this.statusMap[i]
        })
      }
      // 去掉不限状态
      arr.shift(0)
      arr.pop()
      arr.pop()
      return arr
    },
    assetsArr () {
      let arr = []
      for (let i in this.assetsMap) {
        arr.push({
          value: i,
          text: this.assetsMap[i]
        })
      }
      return arr
    },
    channelArr () {
      let arr = []
      for (let i in this.channelMap) {
        arr.push({
          value: i,
          text: this.channelMap[i]
        })
      }
      return arr
    },
    ifStudentArr () {
      let arr = []
      for (let i in this.ifStudentMap) {
        arr.push({
          value: i,
          text: this.ifStudentMap[i]
        })
      }
      return arr
    }
  },
  data () {
    return {
      isEditing: false,
      clipParams: {original: 2, type: UPLOAD_TYPE.cover},
      coverParams: { type: UPLOAD_TYPE.cover },
      wxCodeParams: { type: UPLOAD_TYPE.wxCode },
      coverFile: null, // 裁切后的file对象
      wxCodeFile: null,
      isUpdateInfo: false,
      areaColumns: 2,
      isNativeForeign: false, // 籍贯地是否海外
      isForeign: false, // 所选地区是否海外
      showPicker: false,
      pickerType: 1,
      pickerData: [],
      showChatCodePop: false,
      infoData: {
      },
      limitLength: 500,
      isShowDialog: false,
      isShowClip: false,
      // 上传裁剪的封面图
      coverClipFile: '',
      // 裁剪原图
      tempImg: '',
      // 传给oss的裁剪原图字段
      clipOriginFile: '',
      isShowPreview: false,
      previewIndex: 0,
      timer: 0,
      // 上传封面图弹窗
      showUploadRequestModal: false,
      // 上传封面图弹窗trigger
      showUploadRequest: false
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.query.upd) {
        this.isUpdateInfo = true
      } else {
        this.isUpdateInfo = false
      }
    }
  },
  methods: {
    ...mapActions({
      fetchUserData: 'fetchUserData'
    }),
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),
    // 计算出生肖
    calculater (year) {
      var arr1 = ['猴', '鸡', '狗', '猪', '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊']
      return /^\d{4}$/.test(year) ? `属${arr1[year % 12]}` : false
    },
    // 个人资料配图
    selectedImg (e) {
      if (!e.file) {
        return this.$toast('获取图片失败')
      }
      this.tempImg = e.file
      this.isShowClip = true
    },
    selectedOriginImg (e) {
      this.coverFile = e.file
    },

    coverPicSuccess ({ picId, url, originId, originUrl }) {
      this.infoData.coverPicUrlList[0] = url
      this.infoData.coverPicList[0] = picId
      this.infoData.topPicId = originId
      this.coverClipFile = null
      this.tempImg = null
    },

    originPicSuccess ({ picId, url }) {
      this.infoData.coverPicUrlList.push(url)
      this.infoData.coverPicList.push(picId)
      this.coverFile = null
    },

    WebchatCodeSuccess ({ picId, url }) {
      this.infoData.wechatPicUrl = url
      this.infoData.wechatPicId = picId
      if (this.showChatCodePop) this.showChatCodePop = false
    },

    clipComplete ({ data }) {
      this.coverClipFile = data
      this.clipOriginFile = this.tempImg
      this.isShowClip = false
    },
    deleteClipCover () {
      this.infoData.clipCoverPicUrl = ''
    },
    deleteImg (index) {
      if (index === 0) {
        this.$set(this.infoData.coverPicList, 0, '')
        this.$set(this.infoData.coverPicUrlList, 0, '')
        this.infoData.topPicId = ''
      } else {
        this.infoData.coverPicList.splice(index, 1)
        this.infoData.coverPicUrlList.splice(index, 1)
      }
    },

    switchwebchatPop () {
      if (this.isEditable) {
        this.showChatCodePop = true
      }
    },
    // 上传二维码
    selectedWxCode (e) {
      this.wxCodeFile = e.file
    },
    switchEducation () {
      if (!this.isEditable) return
      this.infoData.schollVisible = this.infoData.schollVisible === 1 ? 0 : 1
    },
    switchComVisible () {
      if (!this.isEditable) return
      this.infoData.companyVisible = this.infoData.companyVisible === 1 ? 0 : 1
    },
    switchSalaryVisible () {
      if (!this.isEditable) return
      this.infoData.annualSalaryVisible = this.infoData.annualSalaryVisible === 1 ? 0 : 1
    },
    /**
     * @description 触发picker选择器
     * @param type { Number }
     *    0: 籍贯
     *    1: 所在地
     *    2: 年薪
     *    3: 婚姻状态
     *    4: 车房情况
     */
    triggerPicker (type) {
      if (!this.isEditable) return
      this.pickerType = type

      switch (type) {
        case 0:
          if (this.infoData.nativeCityId === '900000') {
            this.areaColumns = 1
          } else {
            this.areaColumns = 2
          }
          break
        case 1:
          if (this.infoData.cityId === '900000') {
            this.areaColumns = 1
          } else {
            this.areaColumns = 2
          }
          break
        case 2:
          this.pickerData = this.salaryArr
          break
        case 3:
          this.pickerData = this.statusArr
          break
        case 4:
          this.pickerData = this.assetsArr
          break
        case 5:
          this.pickerData = this.channelArr
          break
        case 6:
          this.pickerData = this.ifStudentArr
          break
      }

      this.showPicker = true
    },
    handleDialogcancel () {
      this.showPicker = false
    },
    handleAreachange (picker, res) {
      if (res[0].code === '900000') {
        this.areaColumns = 1
      } else {
        this.areaColumns = 2
      }
    },
    handleAreaconfirm (res) {
      if (!res[0].code) {
        this.showPicker = false
        return
      }
      this.showPicker = false

      // this.infoData.provice = res[0]
      // 海外地区特殊处理
      if (res[0].code === '900000') {
        if (this.pickerType === 0) {
          this.isNativeForeign = true
          this.infoData.nativeCityId = res[0].code
          this.infoData.nativeLocation = ''
          // this.infoData.nativeLocation = res[0].name === res[1].name ? res[0].name : `${res[0].name}${res[1].name}`
        } else {
          this.isForeign = true
          this.infoData.cityId = res[0].code
          this.infoData.locationCity = ''
          // this.infoData.locationCity = res[0].name === res[1].name ? res[0].name : `${res[0].name}${res[1].name}`
        }
      } else {
        if (this.pickerType === 0) {
          this.isNativeForeign = false
          this.infoData.nativeCityId = res[1].code
          this.infoData.nativeLocation = res[0].name === res[1].name ? res[0].name : `${res[0].name}${res[1].name}`
        } else {
          this.isForeign = false
          this.infoData.locationCity = `${res[1].name}`
          this.infoData.cityId = res[1].code
        }
      }
    },
    handlePickerConfirm (res) {
      this.showPicker = false
      let val = parseInt(res.value)
      switch (this.pickerType) {
        case 2:
          this.infoData.annualSalary = val
          break
        case 3:
          this.infoData.singleStatus = val
          break
        case 4:
          this.infoData.richesInfo = val
          break
        case 5:
          this.infoData.channelCode = val
          break
        case 6:
          this.infoData.ifStudent = val
          break
      }
    },
    switchPost (val) {
      if (!this.isEditable) return
      this.infoData.ifPost = val
    },
    /**
     * @description 保存草稿
     * type 1-手动保存; undefined-自动保存, 默认为1
     */
    saveDraft (type) {
      let typeIn = type
      if (!this.isEditable) {
        return false
      }
      try {
        clearTimeout(this.timer)
        // 不保存有时效的图片
        let tempData = Object.assign({}, this.infoData)
        delete tempData.coverPicUrlList

        if (tempData.coverPicList.join('') === '') {
          delete tempData.coverPicList
        }
        Storage.saveOnday('draftData', tempData, 2)
        if (typeIn === 1) {
          this.$toast('已保存')
        }
        this.timer = setTimeout(this.saveDraft, 5000)
      } catch (err) {
        this.$toast(err)
      }
    },
    /**
     * @description 关闭提交成功弹窗
     */
    confirm () {
      this.isShowDialog = false
      this.$router.back()
    },
    /**
     * @description 提交用户资料方法
     */
    handleSubmit () {
      if (!this.isEditable) return
      // 状态检查
      let fd = this.infoData
      if (!fd.coverPicList || !fd.coverPicList[0]) {
        return this.$toast('请上传封面照片后提交')
      }
      if (!fd.coverPicList || fd.coverPicList.length < 2) {
        return this.$toast('请上传补充照片后提交')
      }
      if (!fd.name) {
        return this.$toast('请填写姓名')
      }
      if (!fd.nickName) {
        return this.$toast('请填写昵称')
      }
      if (this.isForeign) {
        if (!fd.country || !fd.state) {
          return this.$toast('请填写所在地国家和地区')
        }
        fd.locationCity = fd.country + fd.state
      } else {
        // TODO: 没有省份的时候不让提交
        if (!fd.cityId) {
          return this.$toast('请选择所在地省份和城市')
        }
      }
      if (this.isNativeForeign) {
        if (!fd.nativeCountry || !fd.nativeState) {
          return this.$toast('请填写籍贯地国家和地区')
        }
        fd.nativeLocation = fd.nativeCountry + fd.nativeState
      } else {
        // TODO: 没有省份的时候不让提交
        if (!fd.nativeCityId) {
          return this.$toast('请选择籍贯地省份和城市')
        }
      }
      if (!fd.school) {
        return this.$toast('请填写毕业学校')
      }
      if ((typeof fd.ifStudent).toLowerCase() !== 'number') {
        return this.$toast('请选择当前状态')
      }
      if (!fd.ifStudent) {
        if (!fd.job) {
          return this.$toast('请填写工作职位')
        }
        if (!fd.company) {
          return this.$toast('请填写公司名称')
        }
        if (!fd.industry) {
          return this.$toast('请填写公司类型')
        }
        if (!fd.annualSalary) {
          return this.$toast('请选择年薪范围')
        }
      }
      if (!fd.singleStatus) {
        return this.$toast('请选择婚姻状态')
      }
      if (!fd.richesInfo) {
        return this.$toast('请选择车房情况')
      }
      if (!fd.channelCode) {
        return this.$toast('请选择从哪里了解hello部落')
      } else if (fd.channelCode === 99 && !fd.otherChannel) {
        return this.$toast('请填写具体渠道')
      }
      if (!fd.selfDescription) {
        return this.$toast(`请填写自我描述，字数在${this.limitLength}之内`)
      }
      if (!fd.hobby) {
        return this.$toast(`请填写兴趣爱好，字数在${this.limitLength}之内`)
      }
      if (!fd.familyInfo) {
        return this.$toast(`请填写家庭背景，字数在${this.limitLength}之内`)
      }
      if (!fd.personalExperience) {
        return this.$toast(`请填写个人经历，字数在${this.limitLength}之内`)
      }
      if (!fd.ideaPartner) {
        return this.$toast(`请填写理想的另一半要求，字数在${this.limitLength}之内`)
      }
      if (!fd.loveMind) {
        return this.$toast(`请填写爱情观，字数在${this.limitLength}之内`)
      }
      if (!fd.wechatPicId) {
        return this.$toast('请上传微信二维码图片')
      }
      if (fd.ifPost === -1) {
        return this.$toast('请选择是否愿意在hello部落公众号上发帖晒资料')
      }

      // 删除证件相关字段
      // pending接口没返回以下字段，暂时注释
      /* delete fd.identityPicList
      delete fd.identityPicUrlList
      delete fd.identityAuthReason
      delete fd.identityAuthTime
      delete fd.identityCommitTime
      delete fd.workPicList
      delete fd.workPicUrlList
      delete fd.workAuthReason
      delete fd.workAuthTime
      delete fd.workCommitTime
      delete fd.educationPicList
      delete fd.educationPicUrlList
      delete fd.educationAuthReason
      delete fd.educationAuthTime
      delete fd.educationCommitTime */

      // 修改资料后，设置状态为待审核
      this.infoData.basedataAuth = 1

      this.$root.openLoading()
      this.$http('/api/member/saveMemberPending', this.infoData).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000' || res.code === '200003') {
          // TODO: 更新个人信息
          if (res.code === '0000') {
            this.updateUserData({
              basedataAuth: 1
            })
          } else {
            this.updateUserData({ singleStatus: this.userData.singleStatus })
          }
          this.isShowDialog = true
          // 更新成功后即可删除草稿
          clearTimeout(this.timer)
          Storage.remove('draftData')
        } else {
          this.$toast(res.msg)
        }
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
      })
    },
    showPreview (index) {
      this.previewIndex = index
      this.isShowPreview = true
    },
    changePreview (index) {
      this.$refs['swipe'].swipeTo(index)
    },
    closeRequestModal () {
      this.showUploadRequestModal = false
      this.showUploadRequest = false
      this.$nextTick(() => {
        let dom = document.querySelector('#uploadClipBtn input')
        dom && dom.click()
        let _dom = document.querySelector('#upload-request-mask')
        _dom && _dom.remove()
      })
    }
  },
  mounted () {
    this.$http('/api/member/getMemberPending', {}, 'get').then(res => {
      this.$root.closeLoading()
      if (res.code === '0000') {
        let draftData = {}
        if (this.isEditable) {
          draftData = Storage.loadOntime('draftData')
        }
        draftData = { ...res.data, ...draftData }
        // 初始化封面图数据
        if (!draftData.coverPicList) {
          draftData.coverPicList = ['']
          draftData.coverPicUrlList = ['']
        }

        let arr = [], idArr = []
        if (draftData.coverPicList && draftData.coverPicList.join() !== '')  {
          idArr = [].concat(draftData.coverPicList)
        }
        if (draftData.wechatPicId) {
          idArr.push(draftData.wechatPicId)
        }
        if (idArr.length) {
          this.$http(`/api/member/image/urls`, {
            picIds: idArr.join(',')
          }, 'get').then(res => {
            if (res.code === '0000') {
              draftData.coverPicList.map(_ => {
                arr.push(res.data[_])
              })
              // 赋值微信二维码url
              draftData.wechatPicUrl = res.data[draftData.wechatPicId]
            }
            draftData.coverPicUrlList = arr
          })
        }

        // 没有封面原图id的，直接取裁剪图id
        if (!draftData.topPicId) {
          draftData.topPicId = draftData.coverPicList && draftData.coverPicList[0]
        }

        // 转换为字符串类型
        draftData.cityId = '' + (draftData.cityId ? draftData.cityId : '')
        draftData.nativeCityId = '' + (draftData.nativeCityId ? draftData.nativeCityId : '')

        // 判断是否国外地区
        if (draftData.cityId === '900000') {
          this.isForeign = true
        } else {
          this.isForeign = false
        }
        if (draftData.nativeCityId === '900000') {
          this.isNativeForeign = true
        } else {
          this.isNativeForeign = false
        }

        this.infoData = draftData

        this.saveDraft()
      } else {
        this.$toast(res.msg)
      }
    }).catch(err => {
      this.$toast('获取资料出错，请稍后再试')
    })
  },
  activated () {
    // 注销重新保存功能
    /* if (this.infoData.id) {
      setTimeout(() => {
        this.saveDraft()
      }, 5000)
    } */
    // 是否需要展示上传封面弹窗
    //相隔24小时则弹框
    let intervalTime = 8640000
    let dateTime =Date.parse(new Date())
    let dateTimeOld = Storage.load('showUploadRequestDateTime')
    if (dateTimeOld) {
      if ((dateTime-dateTimeOld) >= intervalTime){
        this.showUploadRequest = true
        // 更新有效时间
        Storage.save('showUploadRequestDateTime', dateTime)
      }else {
        this.showUploadRequest = false
      }

    } else {
      this.showUploadRequest = true
      Storage.save('showUploadRequestDateTime', dateTime)
    }
    let d = this.userData
    if (this.userId && d.firstBaseAuth) {
      wxApi.configShare({
        title: 'Hello单身部落',
        // desc: 'ID号-学历-工作-年龄-城市',
        desc: `${this.mId}-${this.educationMap[d.education]}-${d.ifStudent ? '在读' : d.job}-${d.age}-${parseInt(d.cityId) === 900000 ? (d.country + ' ' + d.state) : this.areaData['city_list'][d.cityId]}`,
        link: `${location.origin}/info-${this.mId}.html`,
        imgUrl: `${d.headPicUrl}`
      })
    } else {
      wxApi.configShare()
    }
  },
  deactivated () {
    clearTimeout(this.timer)
    wxApi.configShare()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 重置提醒弹窗状态
      vm.showChatCodePop = false
      vm.showUploadRequestModal = false
      // 验证手机是否验证
      if (!vm.userData.ifMobileVerify) {
        vm.$router.replace({
          path: '/setUserData/phone.html'
        })
      } else if (to.query.clearCache) {
        Storage.remove('draftData')
        next({
          path: '/baseInfo.html'
        })
      }
    })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";

.van-picker-column__item--selected,
.van-picker__cancel,
.van-picker__confirm,
.van-picker-column__item {
  font-size: 13px;
}
.baseInfo-container {
  .line {
    height: 10px;
  }
  .status-content {
    position: relative;
    padding: 2px 40px;
    background: #ffdceb;
    .status-name {
      padding: 24px 28px 0;
      color: $mainColor;
      font-size: 32px;
      line-height: 44px;
      text-align: center;
    }
    .reason {
      display: block;
      color: $mainColor;
      font-size: 20px;
      line-height: 28px;
      min-height: 28px;
      text-align: center;
    }
  }
  .info-tags {
    padding: 24px 40px 0;
    font-size: 0;
    .tag-group {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .tag {
      flex: 1 1 auto;
      display: inline-block;
      padding: 0 24px;
      color: #6d6d6d;
      font-size: 32px;
      line-height: 64px;
      background: #ededed;
      & + .tag {
        margin-left: 24px;
      }
    }
  }
  .complete-info-box {
    position: relative;
    margin: 40px 40px 12px;
    text-align: center;
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 1px;
      background: #dfdfdf;
    }
    .complete-info {
      position: relative;
      z-index: 10;
      display: inline-block;
      padding: 0 20px;
      color: #9b9b9b;
      font-size: 32px;
      line-height: 44px;
      background: #fff;
    }
  }
  .imgs-content {
    padding: 24px 40px;
    .upload-tips {
      margin-bottom: 24px;
    }
  }
  .title {
    font-size: 32px;
    line-height: 44px;
  }
  .sub-title {
    color: #9b9b9b;
    font-size: 32px;
    line-height: 44px;
  }
  .upload-content {
    display: flex;
    flex-wrap: wrap;
    margin-right: -40px;
    .uploadModel {
      img {
        height: 130px;
      }
    }
  }
  .upload-item {
    position: relative;
    flex: 0 0 196px;
    margin-bottom: 40px;
    margin-right: 40px;
    height: 138px;
    &.select-item {
      border: 1px dashed #cacacd;
    }
  }
  #upload-request-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  #upload-request-img {
    width: 560px;
  }
  #select-file-btn {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .img-item {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .upload-btn {
    margin: 0 auto;
    display: block;
    height: 100%;
  }
  .clipUploadTips {
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    color: #9b9b9b;
    font-size: 20px;
    text-align: center;
    transform: translateY(100%);
  }
  .uploadTips {
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    z-index: 10;
    text-align: center;
  }
  .delete-btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px;
    width: 40px;
    height: 40px;
    border-radius: 0 0 0 12px;
    background: rgba(54, 56, 55, 0.7);
  }
  .input-form {
    padding-left: 40px;
  }
  .input-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 32px 40px 32px 0;
    color: #9b9b9b;
    font-size: 32px;
    line-height: 44px;
    .input {
      width: 0;
      flex: 1 1 auto;
      color: #4a4a4a;
      text-align: right;
      img {
        width: 14px;
        margin-left: 12px;
      }
    }
    .name {
      min-width: 130px;
      font-size: 32px;
      font-weight: bold;
    }
    .value,
    .input {
      font-size: 32px;
    }
    & + .input-item {
      margin-top: 1px;
      border-top: 1px solid #e5e5e5;
    }
    &.strong {
      .name {
        color: #38383c;
      }
      .value {
        color: #cacacd;
      }
      .placeValue {
        color: #9b9b9b;
        font-size: 32px;
      }
    }

    .tooltip {
      position: absolute;
      right: 40px;
      bottom: 10px;
      color: #cacacd;
      font-size: 20px;
      line-height: 28px;
    }
    .private {
      flex: 0 0 96px;
      display: inline-flex;
      align-items: center;
      margin-left: 60px;
      color: #4a4a4a;
      white-space: nowrap;
      .check-private {
        display: inline-block;
        vertical-align: middle;
        margin-left: 4px;
        width: 40px;
        height: 40px;
        transform: scale(0.7);
        border-radius: 100%;
        border: 1px solid #4a4a4a;
        img {
          display: none;
          margin: 10px auto 0;
          width: 20px;
        }
      }
      &.checked {
        color: $mainColor;
        .check-private {
          border: 1px solid $mainColor;
          img {
            display: block;
          }
        }
      }
    }

  }
  .foreign-input {
    .input {
      text-align: left;
    }
  }
  .select-item.strong {
    .value {
      color: #4a4a4a;
    }
  }
  .webchat-code-item {
    position: relative;
    &.sended {
      .value {
        color: $mainColor;
      }
    }
  }
  .textarea-form {
    padding: 40px;
  }
  .textarea-con {
    position: relative;
    padding: 20px 16px 16px 30px;
    border-radius: 4px;
    border: 1px solid #dedede;
    & + .textarea-con {
      margin-top: 30px;
    }
    .title {
      margin-bottom: 15px;
      font-size: 32px;
      line-height: 44px;
      font-weight: bold;
    }
    .text-num {
      color: #d3d3d3;
      text-align: right;
    }
  }
  .textarea {
    display: block;
    width: 100%;
    height: 150px;
    font-size: 28px;
    line-height: 40px;
    resize: none;
    overflow-y: auto;
  }
  .upd-info {
    position: sticky;
    bottom: 0;
    left: 0;
    padding: 34px;
    border-top: 1px solid #dfdfdf;
    color: #ff3e90;
    font-size: 32px;
    line-height: 44px;
    text-align: center;
    background: #fff;
  }
  .btns {
    position: sticky;
    bottom: 0;
    left: 0;
    font-size: 0;
    z-index: 10;
    border-top: 1px solid #dfdfdf;
    .btn {
      display: inline-block;
      width: 50%;
      padding: 30px;
      font-size: 32px;
      line-height: 52px;
      text-align: center;
    }
    .draft-btn {
      color: #4a4a4a;
      background: #fff;
    }
    .submit-btn {
      color: #fff;
      font-weight: bold;
      background: $mainColor;
      &.disable {
        background: #9b9ba1;
      }
    }
  }
  .van-popup-webchat {
    height: 100%;
    .btns {
      padding: 20px;
      box-shadow:0px 1px 4px 0px rgba(113,113,113,0.5);
    }
    .disagree-btn {
      display: inline-block;
      vertical-align: middle;
      width: 280px;
      color: #4a4a4a;
      font-size: 32px;
      line-height: 84px;
      text-align: center;
      border-radius:44px;
      border:1px solid rgba(74,74,74,1);
    }
    .oss-container {
      display: inline-block;
      vertical-align: middle;
      margin-left: 30px;
      width: 280px;
      text-align: center;
      border-radius:44px;
      border:1px solid $mainColor;
    }
  }
  .upload-code-pop {
    display: flex;
    flex-flow: column nowrap;
    padding: 0;
    height: 100%;
    text-align: center;
    overflow: hidden;
    /* .pop-title {
      padding: 30px 0;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
    .close-img {
      display: block;
      width: 40px;
      height: 40px;
    } */
    .tips {
      padding: 0 40px;
      flex: 1 1 auto;
      text-align: left;
      overflow: auto;
    }
    .tips-title {
      padding-top: 10px;
      font-size: 32px;
      line-height: 44px;
    }
    .tips-item {
      margin-top: 20px;
      font-size: 28px;
      line-height: 40px;
    }
    .upload-btn {
      position: relative;
      height: 88px;
      border-radius: 88px;
      color: $mainColor;
      font-size: 32px;
      line-height: 84px;
      text-align: center;
    }
    .upload-input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    .code-img {
      display: block;
      margin: 0 auto;
      width: 440px;
    }
    .reupload-btn {
      position: relative;
      margin-top: 50px;
      display: inline-block;
      color: $mainColor;
      font-size: 28px;
      line-height: 40px;
    }
  }
  #upload-webchat-trigger {
    padding: 40px 40px 30px;
    text-align: center;
    .title {
      color: #383838;
      font-size: 32px;
      line-height: 1;
    }
    .webchat-code-item {
      margin: 30px auto 0;
      width: 160px;
      height: 285px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px solid #ccc;
      .upload-icon {
        margin-bottom: 18px;
        width: 40px;
      }
    }
    .word {
      color: rgba(#000, 0.75);
      font-size: 28px;
      line-height: 40px;
    }
    .webchat-code {
      position: relative;
      margin: 30px auto 0;
      max-width: 50%;
      .uploaded-code {
        display: block;
        margin: 0 auto;
        max-width: 100%;
      }
      .reupload-word {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: #fff;
        font-size: 28px;
        line-height: 60px;
        text-align: center;
        background: rgba(255, 62, 144, 0.6);
      }
    }
  }
  #accept-to-post {
    padding: 40px 40px 80px;
    text-align: center;
    .deals {
      margin-bottom: 40px;
      padding-top: 12px;
      color: #38383C;
      font-size: 32px;
      line-height: 1;
    }
    .title {
      color: #383838;
      font-size: 32px;
      line-height: 1;
    }
    .tab-con {
      font-size: 0;
    }
    .tab {
      position: relative;
      display: inline-block;
      margin: 30px auto;
      width: 200px;
      border: 2px solid #ededed;
      color: rgba(#000, 0.5);
      font-size: 28px;
      line-height: 60px;
      background: #ededed;
      border-radius: 4px;
      img {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 28px;
      }
      & + .tab {
        margin-left: 60px;
      }
      &.active {
        border: 2px solid $mainColor;
        color: $mainColor;
        background: #fff;
      }
    }
    .tips {
      color: rgba(#000, 0.5);
      font-size: 28px;
      line-height: 40px;
      text-align: left;
    }
  }
}
</style>
